export var AddToCartState;
(function (AddToCartState) {
    AddToCartState["DISABLED"] = "DISABLED";
    AddToCartState["ENABLED"] = "ENABLED";
    AddToCartState["OUT_OF_STOCK"] = "OUT_OF_STOCK";
})(AddToCartState || (AddToCartState = {}));
export var ADD_FREE_PRODUCTS_PUBLIC_DATA_KEYS = {
    ALLOW_FREE_PRODUCTS: 'ALLOW_FREE_PRODUCTS',
};
//# sourceMappingURL=constants.js.map